export const GIFS_NAMES = [
  { value: "gif-1", label: "gif-1" },
  { value: "gif-2", label: "gif-2" },
  { value: "gif-3", label: "gif-3" },
  { value: "gif-4", label: "gif-4" },
  { value: "gif-5", label: "gif-5" }
];
